/**
 * Página: Hospitais e Saúde
 */
import SegmentPage from '../../components/SegmentPage'

const segment = {
  name: 'Hospitais',
  tagline: 'Saúde que cuida de quem cuida.',
  description: 'Controle de jornada para profissionais de saúde, verificação de EPIs hospitalares e compliance com NR-32.',
  icon: '🏥',
  color: '#10B981',
  gradient: 'linear-gradient(135deg, #10B981 0%, #06B6D4 100%)',
  painPoints: [
    'Turnos rotativos complexos de gerenciar',
    'Profissionais em múltiplos setores',
    'EPIs específicos por área (UTI, Centro Cirúrgico)',
    'Compliance rigoroso com NR-32',
    'Controle de banco de horas em plantões',
    'Fadiga e burnout não identificados',
  ],
  benefits: [
    'Ponto facial sem toque (higiene)',
    'Controle de turnos rotativos automático',
    'Verificação de EPIs por setor',
    'Alertas de carga horária excessiva',
    'Gestão de plantões e escalas',
    'Relatórios de compliance NR-32',
  ],
  nrs: ['NR-32', 'NR-6', 'NR-9', 'NR-15'],
  stats: [
    { value: '-89%', label: 'Erros de Ponto' },
    { value: '100%', label: 'NR-32' },
    { value: '+15%', label: 'Satisfação' },
    { value: '0', label: 'Contato Físico' },
  ],
  testimonial: {
    quote: 'O ponto facial sem toque foi essencial durante a pandemia. Hoje não vivemos sem o WorkStream.',
    author: 'Dra. Ana Beatriz',
    role: 'Diretora Administrativa',
    company: 'Hospital Santa Cruz',
  },
}

export default function Hospitais() {
  return <SegmentPage segment={segment} />
}

